/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PharmacyExternalAIAssistantScope {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  DirectVisit = "direct_visit",
}

export function PharmacyExternalAIAssistantScopeFromJSON(json: any): PharmacyExternalAIAssistantScope {
  return PharmacyExternalAIAssistantScopeFromJSONTyped(json, false);
}

export function PharmacyExternalAIAssistantScopeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyExternalAIAssistantScope {
  return json as PharmacyExternalAIAssistantScope;
}

export function PharmacyExternalAIAssistantScopeToJSON(value?: PharmacyExternalAIAssistantScope | null): any {
  return value as any;
}
